/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `FULL_MATCH` - Based on historical quotes matching exactly.
* `INCOTERMS_MISMATCH` - Based on historical quotes where incoterms might not match the request.
* `ORIGIN_COUNTRY_MISMATCH` - Based on historical quotes where origin country might not match the requested origin, but port of loading matches exactly.
* `DESTINATION_COUNTRY_MISMATCH` - Based on historical quotes where destination country might not match the requested destination, but port of discharge matches exactly.
* `BOTH_ORIGIN_AND_DESTINATION_COUNTRY_MISMATCH` - Based on historical quotes where both origin and destination countries might not match the request, but ports of loading and discharge match exactly.
* `POL_MISMATCH` - Based on historical quotes where port of loading might not match the requested port, but country of the port matches the requested port's country.
* `POD_MISMATCH` - Based on historical quotes where port of discharge might not match the requested port, but country of the port matches the requested port's country.
* `BOTH_POL_AND_POD_MISMATCH` - Based on historical quotes where both port of loading and port of discharge might not match the request, but countries of the ports match the requested ports' countries.
* `CONTINENT_TO_CONTINENT_APPROXIMATION` - Based on pre-defined corridors between continents, only provided as a very rough fallback estimate in case other options are not available.
* `ROAD_PER_KM_ESTIMATE` - Based on the rough estimation of what distance a truck can typically cover in a day.
 */
export type TransitTimeSourceExplanation = typeof TransitTimeSourceExplanation[keyof typeof TransitTimeSourceExplanation];


export const TransitTimeSourceExplanation = {
  FULL_MATCH: 'FULL_MATCH',
  INCOTERMS_MISMATCH: 'INCOTERMS_MISMATCH',
  ORIGIN_COUNTRY_MISMATCH: 'ORIGIN_COUNTRY_MISMATCH',
  DESTINATION_COUNTRY_MISMATCH: 'DESTINATION_COUNTRY_MISMATCH',
  BOTH_ORIGIN_AND_DESTINATION_COUNTRY_MISMATCH: 'BOTH_ORIGIN_AND_DESTINATION_COUNTRY_MISMATCH',
  POL_MISMATCH: 'POL_MISMATCH',
  POD_MISMATCH: 'POD_MISMATCH',
  BOTH_POL_AND_POD_MISMATCH: 'BOTH_POL_AND_POD_MISMATCH',
  CONTINENT_TO_CONTINENT_APPROXIMATION: 'CONTINENT_TO_CONTINENT_APPROXIMATION',
  ROAD_PER_KM_ESTIMATE: 'ROAD_PER_KM_ESTIMATE',
} as const;
